import { z } from 'zod';

export const PROTOCOLS = ['ANY', 'TCP', 'UDP', 'ICMP'] as const;

export const protocolSchema = z.enum(PROTOCOLS);
